<template>
  <section class="upload-photo">
    <figure :style="{height: height+'px'}">
      <div
        class="cover-image"
        v-if="!imageSrc"
        :style="{ backgroundImage: `url('${defultFile}')`}"
        @click="showImage"
      ></div>

      <div
        class="cover-image"
        v-else
         :style="{ backgroundImage: `url('${imageSrc}')`}"
        @click="showImage"
      ></div>
      <input
        class="uplodaer"
        @change="uploadImage"
        type="file"
        name="featuredImage"
        accept="image/*"
        v-if="!imageSrc"
        title="برای آپلود تصویر درگ کنید"
      >
    </figure>
    <div class="form-action text-center font-14">
      <div class="btn-uploder bttn-float bttn bttn-success font-16 text-light">
        <i class="mdi mdi-plus"></i>
        آپلود تصویر
        <input
          class="uplodaer"
          @change="uploadImage"
          type="file"
          title="برای آپلود تصویر کلیک کنید"
          name="featuredImage"
          accept="image/*"
        >
      </div>
    </div>
    <div class="d-flex flex-column justify-content-end text-center mt-1 font-12">
      <span class="mb-1">حجم مجاز : {{scale.size}} kb</span>
      <span>فرمت های مجاز : .jpg,.png</span>
      <span class="d-inline-block ltr">{{pixelImage}}</span>
    </div>
  </section>
</template>

<script>
var vm;
export default {
  name: "upload-photo",

  props: {
    defultFile: {
      type: String,
      default: "/src/assets/img/avatar.png"
    },
    height: {
      type: String,
      default: "75"
    },
    pixelImage: {
      type: String,
      default: "250"
    },
    scale: {
      type: Object,
      default() {
        return {
          min: 0.9,
          max: 1.1,
          size: 100
        };
      }
    }
  },
  data() {
    return {
      imageSrc: null,
      isGallery: false
    };
  },
  computed: {},
  mounted() {
    vm = this;
  },
  methods: {
    showImage() {
      this.isGallery = true;
    },
    uploadImage: function(e) {
      var files = e.target.files;
      if (!files[0]) {
        return;
      }
      var img = new Image();
      var _URL = window.URL || window.webkitURL;
      img.src = _URL.createObjectURL(e.target.files[0]);
      img.onload = () => {
        var roti = img.width / img.height;
        roti.toFixed(2);
        if (roti <= vm.scale.max && roti >= vm.scale.min) {
          let filesize = (files.size / 1024 / 1024).toFixed(2); // MB
          if (filesize > 100) {
            vm.$root.showWarnMsg({
              message: `حجم فایل نباید بیشتر از ${vm.scale.size} MB باشد ... `
            });
            return;
          }
          vm.$emit("getFile", files[0], e);
          var data = new FormData();
          data.append("featuredImage", files[0]);
          var reader = new FileReader();
          reader.onload = e => {
            vm.imageSrc = e.target.result;
          };
          reader.readAsDataURL(files[0]);
        } else {
          vm.$root.showWarnMsg({
            message: "تناسب عکس را رعایت کنید... "
          });
        }
      };

      // this.$axios.$post(`${url.blog}/posts/files`, data,{ headers: { 'blog-token': readCookie('blog-token') } }).then(res => {
      //         this.$store.commit('upload/uploadPhoto', res.fileName)
      //     })
    }
  }
};
</script>

<style lang="less">
@import (reference) "../../assets/css/variable.less";
.upload-photo {
  .box-clear;
  figure {
    position: relative;
    overflow: hidden;
    cursor: pointer;
    img {
      width: 100%;
    }
    .cover-image {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    }
    input.uplodaer {
      position: absolute;
      left: 0;
      margin: auto;
      font-size: 999px;
      min-height: 100%;
      opacity: 0;
      top: 0;
      right: 0;
      bottom: 0;
      display: block;
      cursor: pointer;
    }
    margin-bottom: 20px;
  }
  .btn-uploder {
    position: relative;
    overflow: hidden;
    cursor: pointer;
    input.uplodaer {
      position: absolute;
      left: 0;
      cursor: pointer;
      margin: auto;
      width: 100%;
      font-size: 999px;
      min-height: 100%;
      opacity: 0;
      top: 0;
      right: 0;
      bottom: 0;
      display: block;
    }
    &:hover {
      opacity: 0.7;
    }
  }
}
.gallery {
  // width: 80%;
  // margin: 10px auto;
  text-align: center;
  img {
    // width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/min-component/upload-photo.vue